import { formatDate } from "@clipboard-health/date-time";
import { ToggleButton } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { isSameDay, isYesterday, startOfDay } from "date-fns";
import { useMemo } from "react";

import { FiltersToggleButtonGroup } from "../ShiftDiscovery/Filters/BottomSheet/ToggleButtonGroup";
import { getDaysInRange } from "../utils/getDaysInRange";

export interface DateListProps {
  selectedDate: Date;
  minDate: Date;
  maxDate: Date;
  today?: Date;
  onChange: (date: Date) => void;
}

export function DateList(props: DateListProps) {
  const { minDate, maxDate, today, selectedDate, onChange } = props;

  const days = useMemo(
    () => getDaysInRange({ startDate: startOfDay(minDate), endDate: startOfDay(maxDate) }),
    [minDate, maxDate]
  );

  return (
    <Stack direction="row" spacing={2} flexGrow={1}>
      <FiltersToggleButtonGroup
        exclusive
        value={selectedDate.toISOString()}
        onChange={(value) => {
          if (isDefined(value)) {
            onChange(new Date(value));
          }
        }}
      >
        {days.map((day) => (
          <ToggleButton
            key={day.toISOString()}
            value={day.toISOString()}
            sx={{ textWrap: "nowrap" }}
            selected={formatDate(selectedDate) === formatDate(day)}
          >
            {isDefined(today) && `${resolveDayLabel(day, today)} `}
            {formatDate(day)}
          </ToggleButton>
        ))}
      </FiltersToggleButtonGroup>
    </Stack>
  );
}

function resolveDayLabel(day: Date, today?: Date) {
  if (isDefined(today) && isSameDay(day, today)) {
    return "Today";
  }

  if (isYesterday(day)) {
    return "Yesterday";
  }

  return "";
}
